"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsonrpc_1 = require("@iov/jsonrpc");
const socket_1 = require("@iov/socket");
function isNonNull(t) {
    return t !== null;
}
class WsEthereumRpcClient {
    constructor(baseUrl) {
        this.socket = new socket_1.ReconnectingSocket(baseUrl);
        this.events = this.socket.events;
        this.socket.connect();
    }
    async run(request) {
        const response = new Promise((resolve, reject) => {
            this.socket.events
                .map((event) => {
                try {
                    return jsonrpc_1.parseJsonRpcResponse(JSON.parse(event.data));
                }
                catch (error) {
                    return null;
                }
            })
                .filter(isNonNull)
                .filter((data) => data.id === request.id)
                .take(1)
                .addListener({
                next: resolve,
                error: reject,
            });
        });
        this.socket.queueRequest(JSON.stringify(request));
        return response;
    }
    async socketSend(request, ignoreNetworkError = false) {
        const data = JSON.stringify(request);
        try {
            this.socket.queueRequest(data);
        }
        catch (error) {
            if (!ignoreNetworkError)
                throw error;
        }
    }
    disconnect() {
        this.socket.disconnect();
    }
}
exports.WsEthereumRpcClient = WsEthereumRpcClient;
//# sourceMappingURL=wsethereumrpcclient.js.map